if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      const syncGiftOptions = () => {
        const wrap = this.form.querySelector('.product-gift-checkbox');
        const options = this.form.querySelector('#variant-options');
        if (!wrap || !options) return;
        const enabled = wrap.checked && !wrap.disabled;
        options.hidden = !enabled;
        options.style.display = enabled ? 'flex' : 'none';
        options.setAttribute('aria-hidden', String(!enabled));
        const choice = Array.from(options.querySelectorAll('.variant-option')).find(option => option.dataset.variantId === wrap.value);
        const property = this.form.querySelector('[name="properties[Gift Wrapping]"]');
        if (property) property.value = enabled && choice ? choice.dataset.variantName : '';
      };
      this.form.addEventListener('change', event => {
        if (event.target.matches('.product-gift-checkbox')) syncGiftOptions();
      });
      syncGiftOptions();
      const syncPersonalisation = () => {
        const option = this.form.querySelector('.product-personalisation-wrap input[type="checkbox"]');
        const container = this.form.querySelector('.personalisation-value');
        const field = this.form.querySelector('#allergies');
        if (!option || !container || !field) return;
        const enabled = option.checked && !option.disabled;
        container.hidden = !enabled;
        container.classList.toggle('active', enabled);
        container.style.display = enabled ? 'block' : 'none';
        field.disabled = !enabled;
        field.required = enabled;
        if (!enabled) {
          field.removeAttribute('aria-invalid');
          const error = this.form.querySelector('#personalisationError');
          if (error) error.textContent = '';
        }
      };
      this.form.addEventListener('change', event => {
        if (event.target.matches('.product-personalisation-wrap input[type="checkbox"]')) syncPersonalisation();
      });
      syncPersonalisation();
      // Support each form independently, including quickview and B2B forms.
      this.form.addEventListener('click', (event) => {
        const choice = event.target.closest('#variant-options .variant-option');
        const wrap = this.form.querySelector('.product-gift-checkbox');
        if (!choice || !this.form.contains(choice) || !wrap || wrap.disabled || choice.disabled) return;
        this.form.querySelectorAll('#variant-options .variant-option').forEach(option => {
          const selected = option === choice;
          option.classList.toggle('selected', selected);
          if (option.hasAttribute('aria-pressed')) option.setAttribute('aria-pressed', String(selected));
        });
        wrap.value = choice.dataset.variantId;
        wrap.checked = true;
        const property = this.form.querySelector('[name="properties[Gift Wrapping]"]');
        if (property) property.value = choice.dataset.variantName;
        syncGiftOptions();
      });
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      // Keep the spinner behavior for the button clicked
      const submitButton = evt.submitter || this.querySelector('[type="submit"]');
      const spinner = submitButton.querySelector('.loading-overlay__spinner');
      
      if (submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const mainProductId = this.form.querySelector('[name=id]').value;
      
      // Original quantity handling logic (without nearest search)
      const mainProductQuantityElement = this.form.querySelector('[name=quantity]');
      const mainProductQuantity = mainProductQuantityElement ? mainProductQuantityElement.value : 1;

      const giftWrapCheckbox = this.form.querySelector('.product-gift-checkbox');
      const giftWrapVariantId = giftWrapCheckbox ? giftWrapCheckbox.value : null;

      const personalisationCheckbox = this.form.querySelector('.product-personalisation-wrap input[type="checkbox"]');
      const personalisationVariantId = personalisationCheckbox ? personalisationCheckbox.value : null;

      const personalisationTextArea = this.form.querySelector('#allergies');
      const personalisationError = this.form.querySelector('#personalisationError');
      const giftWrapSelected = !!giftWrapCheckbox?.checked && !giftWrapCheckbox.disabled;
      const personalisationSelected = !!personalisationCheckbox?.checked && !personalisationCheckbox.disabled;
      const selectedWrap = Array.from(this.form.querySelectorAll('#variant-options .variant-option')).find(option => option.dataset.variantId === giftWrapVariantId);
      const selectedWrapName = (selectedWrap?.dataset.variantName || '').trim();
      if (personalisationError) personalisationError.innerText = '';
      personalisationTextArea?.removeAttribute('aria-invalid');
      if (giftWrapSelected && (!giftWrapVariantId || !selectedWrapName)) {
        this.handleErrorMessage('Please choose an available gift wrapping colour.');
        submitButton.removeAttribute('aria-disabled'); submitButton.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        return;
      }

      // Check if personalisation checkbox is checked but personalisation text area is empty
      if (personalisationSelected && (!personalisationTextArea || personalisationTextArea.value.trim() === '' || personalisationTextArea.value.length > 20)) {
        if (personalisationError) personalisationError.innerText = 'Enter personalisation of up to 20 characters, including spaces.';
        personalisationTextArea?.setAttribute('aria-invalid', 'true');
        personalisationTextArea?.focus();
        submitButton.removeAttribute('aria-disabled');
        submitButton.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        return; // Stop form submission
      }

      const properties = {};
      // Build from successful controls, and derive optional properties from this form's selection.
      for (const [name, value] of Array.from(formData.entries())) {
        if (!name.startsWith('properties[')) continue;
        formData.delete(name); // Avoid stale top-level copies alongside the nested items payload.
        if (name === 'properties[Gift Wrapping]' || name === 'properties[Personalisation]') continue;
        properties[name] = value;
      }
      if (giftWrapSelected) properties['properties[Gift Wrapping]'] = selectedWrapName;
      if (personalisationSelected) properties['properties[Personalisation]'] = personalisationTextArea.value.trim();

      formData.delete('id'); // Ensure no single 'id' field is present
      formData.append('items[0][id]', mainProductId);
      formData.append('items[0][quantity]', mainProductQuantity);
      Object.keys(properties).forEach(key => {
        formData.append(`items[0][properties][${key.slice(11, -1)}]`, properties[key]);
      });

      let itemIndex = 1;
      if (giftWrapSelected) {
        formData.append(`items[${itemIndex}][id]`, giftWrapVariantId);
        formData.append(`items[${itemIndex}][quantity]`, 1);
        itemIndex++;
      }

      if (personalisationSelected) {
        formData.append(`items[${itemIndex}][id]`, personalisationVariantId);
        formData.append(`items[${itemIndex}][quantity]`, 1);
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: mainProductId, errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            submitButton.setAttribute('aria-disabled', true);
            submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: mainProductId});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
